import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './MeetingsAndCollectionsStyle';
import Meetings from './Meetings';
import Collections from './Collections';
import Dialog from '@material-ui/core/Dialog';
import CreationWizard from './Wizard/CreationWizard';
import DialogContent from '@material-ui/core/DialogContent';
import { withStyles } from '@material-ui/core/styles';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import LocalizedStrings from '../../Localization/localization';

class MeetingsAndCollections extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalIsOpen: false,
            modalType: undefined,
        };
    }

    openModal = (modalType) => {
        this.setState({ modalIsOpen: true, modalType });
    }

    closeModal = () => {
        this.setState({ modalIsOpen: false, modalType: undefined });
    }

    /*
    Calendar
    Appointments
    Collections
    */

    render() {
        return (
            <Fragment>
                <div className={`App-page-background ${this.props.backgroundColor}`} />
                <div style={styles.container}>
                    <Meetings
                        openModal={this.openModal}
                        openContent={this.props.openContent}
                        openFileViewer={this.props.openFileViewer}
                        customizationStyle={this.props.customizationStyle} />
                    <Collections
                        canCreate={true}
                        canEdit={true}
                        openModal={this.openModal}
                        openContent={this.props.openContent} />
                    <Dialog
                        fullScreen={this.props.fullScreen}
                        open={this.state.modalIsOpen}
                        onClose={this.closeModal}
                        fullWidth={true}
                        maxWidth={'xl'}
                        PaperProps={{ classes: { root: this.props.classes.paper } }}>
                        {this.props.fullScreen &&
                            <DialogActions>
                                <Button onClick={this.closeModal} color="primary">
                                    {LocalizedStrings.close}
                                </Button>
                            </DialogActions>
                        }
                        <DialogContent style={this.props.fullScreen === true ? { padding: '0px' } : {}}>
                            <CreationWizard
                                isSmartphone={this.props.fullScreen}
                                notify={this.props.notify}
                                closeModal={this.closeModal}
                                modalType={this.state.modalType}
                                openContent={this.props.openContent}
                            />
                        </DialogContent>
                    </Dialog>
                </div>
            </Fragment>
        );
    }
}
MeetingsAndCollections.propTypes = {
    notify: PropTypes.func,
    openContent: PropTypes.func.isRequired,
    openFileViewer: PropTypes.func.isRequired,
    customizationStyle: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    fullScreen: PropTypes.bool.isRequired,
    backgroundColor: PropTypes.string.isRequired,
};

export default withStyles(styles)(withMobileDialog()(MeetingsAndCollections));